import jwtDecode from 'jwt-decode';

class AuthService {
  // Stores the access and refresh tokens in the session storage
  setSession = (tokenObj) => {
    if (tokenObj) {
      sessionStorage.setItem('accessToken', JSON.stringify(tokenObj));
    } else {
      sessionStorage.removeItem('accessToken');
    }
  }

  // Retrieves the current access and refresh tokens from the
  // session storage.
  getTokenObj = () => {
    const tokenObj = sessionStorage.getItem('accessToken');
    return tokenObj ? JSON.parse(tokenObj) : null;
  };

  // Checks whether an authentication token exists.
  isAuthenticated = () => !!this.getTokenObj();

  // Gets the current access token.
  getAccessToken = () => this.getTokenObj()?.accessToken;

  // Gets the ID of the current user.
  getUserId = () => this.getTokenObj()?.userId;

  // Gets the expiration of the given token in seconds.
  getTokenExpiration = (token) => jwtDecode(token).exp - new Date().getTime() / 1000;
}

const authService = new AuthService();
export default authService;
